type SubparticipantSchema = {
  id: number | null
  shortName: string | null
}

/**
 * Compares two players by `id` if both have non-null IDs,
 * otherwise compares by `shortName` when both IDs are null.
 */
export function isSameSubparticipant(
  a: SubparticipantSchema,
  b: SubparticipantSchema,
): boolean {
  if (a.id && b.id) {
    return a.id === b.id
  }

  return !a.id && !b.id && a.shortName === b.shortName
}
